/** create subarray of array view
 *
 * - `view` — the view
 * - `offset` — index to start from
 * - `length` — length of the subarray to create
 */
export function subarray(view: Int8Array, offset: number, length: number) {
    const sub = new ArrayBuffer(length);
    const subView = new Int8Array(sub);
    for (let i = 0; i < length; i++)
        subView[i] = view[offset + i]!;
    return sub;
}
